import React from 'react';
import { ReactComponent as PlusIcon } from '../../assets/icons/PlusIcon.svg';

import classes from './BusinessIntegration.module.scss';
import Button from '../Buttons/Button/Button';

const BusinessIntegration = ({ className, title, description, children, addIntegration, textIntegration }) => {
  const containerClasses = [classes.container];
  if (className) {
    containerClasses.push(className);
  }
  return (
    <div className={`${containerClasses.join(' ')} card-md`}>
      <div className={classes.title}>
        <span className='semibold-18'>{title}</span>
        <Button onClick={addIntegration} className={classes.button} Icon={PlusIcon} custom='quaternary'>
          {textIntegration}
        </Button>
      </div>
      <span className={`${classes.description} medium-16`}>{description}</span>
      {children}
    </div>
  );
};

export default BusinessIntegration;
